import axios from "axios";
import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import {MANUAL_PAYMENT_CANCEL, MANUAL_PAYMENT_DETAIL} from "../../../../constants/api.constants";
import {manualPaymentCancelConstants} from "../../../../constants/Payment/manualPaymentCancel.constants";

/**
 * İşlem iptal / durum güncelle / kısmi iade.
 * params: { code?, order_id?, status?, refund_amount?, new_amount?, message? }
 * (Tam iptal: status: 4 — Kısmi iade: refund_amount ya da new_amount)
 */
export function manualPaymentCancel(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                ...params,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'MANUAL_PAYMENT_CANCEL',
            payload: axios.post(MANUAL_PAYMENT_CANCEL, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

/**
 * İşlem detay / audit (kim ne yaptı).
 * params: { code?, order_id? }
 */
export function manualPaymentDetail(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                ...params,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'MANUAL_PAYMENT_DETAIL',
            payload: axios.post(MANUAL_PAYMENT_DETAIL, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

/**
 * Tam audit raporu (tüm sipariş — ayrı state slice).
 * params: { code?, order_id? }
 */
export function manualPaymentAudit(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                ...params,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'MANUAL_PAYMENT_AUDIT',
            payload: axios.post(MANUAL_PAYMENT_DETAIL, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearManualPaymentAudit() {
    return dispatch => {
        dispatch({
            type: manualPaymentCancelConstants.MANUAL_PAYMENT_AUDIT_CLEAR,
        })
    }
}

export function clearManualPaymentCancel() {
    return dispatch => {
        dispatch({
            type: manualPaymentCancelConstants.MANUAL_PAYMENT_CANCEL_CLEAR,
        })
    }
}

export function clearManualPaymentDetail() {
    return dispatch => {
        dispatch({
            type: manualPaymentCancelConstants.MANUAL_PAYMENT_DETAIL_CLEAR,
        })
    }
}
